import { Component, ChangeDetectorRef, ViewChild, Input, SimpleChanges } from '@angular/core';
import { IonicPage, NavController, NavParams, Events, Content, Navbar } from 'ionic-angular';

import { BrComDao } from '../../service/BrComDao';
import { BrComService } from '../../service/BrComService';
import { Contato } from '../../models/contato';
import { ContatoLocalProvider } from '../../providers/contato-local/contato-local';
import { ContatoProvider } from '../../providers/contato/contato';
import { FotoProvider } from '../../providers/foto/foto';
import { Mensagem, OrigemMensagem, ArquivoMensagem } from '../../models/mensagem';
import { MensagemProvider } from '../../providers/mensagem/mensagem';
import { Platform } from 'ionic-angular';
import { ToastController } from 'ionic-angular';

@Component({
  selector: 'page-conversa-contato',
  templateUrl: 'conversa-contato.html',
})
export class ConversaContatoPage {

  @ViewChild(Content) content: Content;
  @ViewChild(Navbar) navBar: Navbar;
  @Input() contato: Contato;
  private empresa: any;

  constructor(public lc: ChangeDetectorRef, 
    public navCtrl: NavController, 
    private brComDao: BrComDao, 
    private brComService: BrComService, 
    private navParams: NavParams, 
    private events: Events, 
    private fotoProvider : FotoProvider,
    private contatoProvider: ContatoProvider, 
    private contatoLocalProvider: ContatoLocalProvider, 
    private mensagemProvider: MensagemProvider,
    private toastController: ToastController,
    private platform: Platform) {
   // this.contato = this.navParams.get('contato');
   this.empresa = this.brComDao.getEmpresa();

  }

  ngOnInit() {
    this.content.resize();
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes.contato.previousValue) {
      this.processarContatoAnterior(changes.contato.previousValue);
    }
    this.brComService.confirmaUsuarioLogado(this.empresa.CodEmpresa, this.empresa.CodUsuario);
    this.notificarMensagensLidas();
    this.atualizaListaMensagens();
    this.events.subscribe(`msg.contato.${this.contato.idContato}`, () => {
      this.atualizaListaMensagens();
      this.notificarMensagensLidas();
    });
  }

  private processarContatoAnterior(contatoAnterior: Contato) {
    this.events.unsubscribe(`msg.contato.${contatoAnterior.idContato}`);
    this.contatoLocalProvider.removerMensagensAcimaDoLimite(contatoAnterior.idContato);
  }

  ngOnDestroy() {
    this.events.unsubscribe(`msg.contato.${this.contato.idContato}`);
    this.contatoLocalProvider.removerMensagensAcimaDoLimite(this.contato.idContato);
  }

  private notificarMensagensLidas(): void {
    if (this.hasMensagensNaoLidas()) {
      this.contatoProvider.notificarMensagensLidas(this.contato.idContato, this.brComService.getIdDevice()).subscribe();
    }
  }

  private hasMensagensNaoLidas(): boolean {
    if (!this.contato.mensagens) {
      return false;
    }
    const result = this.contato.mensagens.find(m =>  m.idUsuarioOrigem == this.contato.idUsuario 
      && !m.statusMensagemLida)
    if (result) {
      return true;
    }
    return false;
  }

  private getMensagensAntigas(refresher: any): void {
    const mensagensContato = this.contato.mensagens;
    const idMensagemMaisAntiga = mensagensContato[0].idMensagemUsuario;
    this.contatoProvider.getMensagensContato(this.contato.idContato, idMensagemMaisAntiga).subscribe(
      mensagens => {
       if (mensagens) {
        this.contato.mensagens = mensagens.concat(mensagensContato);
        this.contatoLocalProvider.updateContato(this.contato);
       }
      }, () => {
      }, () => {
        refresher.complete();
      }
    )
  }

  private async atualizaListaMensagens(): Promise<void> {
    this.contato.mensagens = this.contatoLocalProvider.getContato(this.contato.idContato).mensagens || [];
    this.detectarMudancas();
    this.scrollBottom();
    this.contatoLocalProvider.marcarMensagensLidas(this.contato.idContato);
  }

  private criarMensagemEnvio(textoMensagem: string): Mensagem {
    const mensagem = this.mensagemProvider.criarMensagemSimples({
      idEnvio: new Date().getTime(),
      idMensagemUsuario: 0,
      mensagem: textoMensagem,
      origem: OrigemMensagem.DIREITA,
      idUsuarioDestino: this.contato.idUsuario,
      idUsuarioOrigem: this.empresa.IdUsuario,
      textoTipoMensagem: '',
      podeSerRespondida: false,
    })
    mensagem.pendente = true;
    return mensagem;
  }  

  private criarMensagemImagemEnvio(): Mensagem {
    const mensagem = this.mensagemProvider.criarMensagemImagem({
      idEnvio: new Date().getTime(),
      idMensagemUsuario: 0,
      link: "",
      origem: OrigemMensagem.DIREITA,
      idUsuarioDestino: this.contato.idUsuario,
      idUsuarioOrigem: this.empresa.IdUsuario,
      textoTipoMensagem: '',
      podeSerRespondida: false
    })
    mensagem.pendente = true;
    return mensagem;
  }

  private criarMensagemArquivoEnvio(arquivo: ArquivoMensagem): Mensagem {
    const mensagem = this.mensagemProvider.criarMensagemArquivo({
      idEnvio: new Date().getTime(),
      idMensagemUsuario: 0,
      arquivo: arquivo,
      origem: OrigemMensagem.DIREITA,
      idUsuarioDestino: this.contato.idUsuario,
      idUsuarioOrigem: this.empresa.IdUsuario,
      textoTipoMensagem: '',
      podeSerRespondida: false
    })
    mensagem.pendente = true;
    return mensagem;
  }

  private detectarMudancas(): void {
      try {
        this.lc.detectChanges();
      } catch (err) {
        console.log("desprezado erro em detectChanges conversa-contato");
      }
  }

  public async enviarMensagem(mensagem: string): Promise<void> {
    if (mensagem.trim() === "") {
      return;
    }
    const msg = this.criarMensagemEnvio(mensagem);
    this.adicionarNovaMensagem(msg);
    this.contatoProvider.enviarMensagemSimples(this.contato.idContato,this.brComService.getIdDevice(), mensagem).subscribe(
      (idEnvio: number) => {
        this.contatoLocalProvider.atualizarMensagemEnviada(this.contato.idContato, msg.idEnvio, idEnvio);
      }, (error) => {
        msg.falhaNoEnvio = true;
        this.contatoLocalProvider.atualizarMensagem(this.contato.idContato, msg);
      }
    )
  }

  private adicionarNovaMensagem(msg: Mensagem): void {
    this.contato.mensagens.push(msg);
    this.detectarMudancas()
    this.content.scrollToBottom(300);
    this.contatoLocalProvider.adicionarNovaMensagem(this.contato.idContato, msg);
  }

  public enviarImagem(imagem: File): void {
    const msg = this.criarMensagemImagemEnvio();
    this.adicionarNovaMensagem(msg);
    this.mensagemProvider.uploadFirebase(imagem).then(
      url => {
        msg.link = url;
        this.contatoLocalProvider.atualizarMensagem(this.contato.idContato, msg);
        this.contatoProvider.enviarMensagemImagem(this.contato.idContato, this.brComService.getIdDevice(), url).subscribe(
          (idEnvio: number) => {
            this.contatoLocalProvider.atualizarMensagemEnviada(this.contato.idContato, msg.idEnvio, idEnvio);
          }, (error) => {
            msg.falhaNoEnvio = true;
            this.contatoLocalProvider.atualizarMensagem(this.contato.idContato, msg);
            setTimeout(
              () => {
                this.content.scrollToBottom(300);
              }, 100
            )
          }
        )
      }, error => {}
    )
  }

  public enviarArquivo(file: File): void {
    const arquivo: ArquivoMensagem = {
      nome: file.name,
      mime: file.type,
      link: ""
    }
    const msg = this.criarMensagemArquivoEnvio(arquivo);
    this.adicionarNovaMensagem(msg);
    this.mensagemProvider.uploadFirebase(file).then(
      url => {
        msg.arquivo.link = url;
        this.contatoLocalProvider.atualizarMensagem(this.contato.idContato, msg);
        this.contatoProvider.envarMensagemArquivo(this.contato.idContato, this.brComService.getIdDevice(), msg.arquivo).subscribe(
          (idEnvio: number) => {
            this.contatoLocalProvider.atualizarMensagemEnviada(this.contato.idContato, msg.idEnvio, idEnvio);
          }, (error) => {
            msg.falhaNoEnvio = true;
            this.contatoLocalProvider.atualizarMensagem(this.contato.idContato, msg);
          }
        )
      }, error => {}
    )
  }

  public isUploadingArquivo(mensagem: Mensagem) {
    return !mensagem.arquivo.link && mensagem.arquivo.link === '';
  }

  private apresentarToast(erro: string): void {
    this.toastController.create({
      message: `Erro: ${erro}`,
      duration: 3000
    }).present();
  }

  public scrollBottom(): void {
    try {
      setTimeout(() => {
        this.content.scrollToBottom();
    }, 300);
    } catch (error) {}
  }

  public getImagemUsuario():string{
    const hash = this.contato.hashFoto;
    if (hash !== "") {
      return this.fotoProvider.getUrlImagemServidor(hash);
    }
      return 'assets/img/usuario.png';
  }

  public abrirLink(url: string) {
    if (url && url !== "") {
      window.open(url, '_blank');
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/conversa-contato/conversa-contato.ts